<template src="./applyModal.pug" lang="pug"></template>

<script>
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import { verifyReaplyConcByTimeAsync, verifyReaplyConcTimeout } from '../../../../utils/verifyReaplyConcByTimeAsync'

export default {
  name: 'ApplyModal',

  components: {
    ConfirmModal,
    ButtonPrimary
  },

  data () {
    return {
      disableButton: false,
      isJustification: false
    }
  },

  computed: {
    allotmentId () {
      return this.$store.getters.idAllotment
    },

    totalAmountForInternalEntries () {
      return this.$store.getters.totalAmountForInternalEntries
    },

    totalAmountForBankEntries () {
      return this.$store.getters.totalAmountForBankEntries
    },

    totalAmountToJustify () {
      return this.calculateTotalToJustify()
    },

    totalDivergence () {
      let value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2)
      return Number(value).toFixed(2)
    },

    finMovAdded () {
      return this.$store.getters.finMovAdded
    },

    bankStatAdded () {
      return this.$store.getters.bankStatAdded
    },

    arrayJustify () {
      return this.$store.getters.arrayJustify
    }
  },

  watch: {
    arrayJustify () {
      this.isJustification = this.$store.getters.arrayJustify.length > 0
    }
  },

  methods: {
    // Criação de lotes
    confirmApplyAllotment () {
      this.$store.dispatch('loadingData').then(() => {
        this.disableButton = true
        let reaplicarConciliacao = this.$store.getters.isReaplyConciliation
        let data = {
          idLote: this.allotmentId,
          idsMovFinanceira: this.generateArrayWithIds(this.finMovAdded),
          idsMovBancaria: this.generateArrayWithIds(this.bankStatAdded),
          valorDivergencia: this.totalDivergence,
          dataBase: new Date(),
          reaplicarConciliacao: reaplicarConciliacao
        }
        this.$store.dispatch('applyConciliation', data)
          .then((response) => {
            if (reaplicarConciliacao) {
              // Alterando mensagem do loading
              this.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica')
              this.$store.dispatch('reaplyConciliation', data)
                .catch((error) => {
                  this.confirmApplyAllotmentError(error)
                })
              // Verificando situacao da conciliacao
              verifyReaplyConcByTimeAsync(
                () => this.$store.dispatch('verifyReaplyConciliation', data),
                this.confirmApplyAllotmentSuccess,
                this.confirmApplyAllotmentError,
                verifyReaplyConcTimeout)
            } else {
              this.confirmApplyAllotmentSuccess(response)
            }
          })
          .catch((error) => {
            this.confirmApplyAllotmentError(error)
          })
      })
    },

    // Acao tomada no sucesso da Criacao de lotes
    confirmApplyAllotmentSuccess (response) {
      this.disableButton = false
      // se for reaplicacao de conciliacao
      if (response.data.data === true) {
        this.$root.$refs.notification.global('S', this.$t(response.data.message))
      } else {
        this.$root.$refs.notification.global('S', response.data.data
          ? (this.totalDivergence === 0.00 || this.totalDivergence === '0.00')
            ? this.$t('conciliacaoManual.sucesso.loteConciliadoOk', {id: response.data.data})
            : this.$t('conciliacaoManual.sucesso.loteDivergenteOk', {id: response.data.data})
          : this.$t(response.data.message))
      }
      this.$store.dispatch('cleanEditState')
      this.closeModal()
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true)
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true)
      this.$store.dispatch('dataLoaded')
    },

    // Acao tomada no erro da Criacao de lotes
    confirmApplyAllotmentError (error = {}) {
      this.disableButton = false
      this.closeModal()
      this.$store.dispatch('dataLoaded')
      this.$root.$refs.notification.global('E', error && error.data && error.data.message
        ? this.$t(error.data.message)
          : error && error.message
          ? this.$t(error.message)
        : this.$t('GENERAL'))
    },

    // Justificativa
    confirmJustify () {
      let reaplicarConciliacao = this.$store.getters.isReaplyConciliation
      let data = {
        idsMovFinanceira: this.generateArrayWithIds(this.finMovAdded),
        idsMovBancaria: this.generateArrayWithIds(this.bankStatAdded),
        idsPlanosConciliacao: this.$store.getters.arrayConciliationPlan,
        valorDivergencia: this.totalDivergence,
        idsMotivosOcorrencia: this.generateArrayIdsOcurrence(this.arrayJustify),
        justificativas: this.arrayJustify,
        dataBase: new Date(),
        reaplicarConciliacao: reaplicarConciliacao
      }
      this.$store.dispatch('loadingData').then(() => {
        this.disableButton = true
        this.$store.dispatch('justifyConciliation', data)
          .then((response) => {
            if (reaplicarConciliacao) {
              // Alterando mensagem do loading
              this.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica')
              this.$store.dispatch('reaplyConciliation', data)
                .catch((error) => {
                  this.confirmJustifyError(error)
                })
              // Verificando situacao da conciliacao
              verifyReaplyConcByTimeAsync(
                () => this.$store.dispatch('verifyReaplyConciliation', data),
                this.confirmJustifySuccess,
                this.confirmJustifyError,
                verifyReaplyConcTimeout)
            } else {
              this.confirmJustifySuccess(response)
            }
          })
          .catch((error) => {
            this.confirmJustifyError(error)
          })
      })
    },

    // Acao tomada no sucesso da Justificativa
    confirmJustifySuccess (response) {
      this.disableButton = false
      this.$store.dispatch('cleanEditState')
      this.closeModal()

      this.$root.$refs.notification.global('S', response.data.data
        ? this.$t(response.data.message, {id: response.data.data}) : this.$t(response.data.message))
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true)
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true)
      this.$store.dispatch('', false)
      this.$store.dispatch('dataLoaded')
    },

    // Acao tomada no erro da Justificativa
    confirmJustifyError (error = {}) {
      this.disableButton = false
      this.closeModal()
      this.$root.$refs.notification.global('E', error && error.data && error.data.message
        ? this.$t(error.data.message)
          : error && error.message
          ? this.$t(error.message)
        : this.$t('GENERAL'))
      this.$store.dispatch('dataLoaded')
    },

    generateArrayIdsOcurrence (list) {
      let result = []
      list.forEach(item => {
        result.push(item.idMotivoOcorrencia)
      })
      return result
    },

    closeModal () {
      $('#applyModal').modal('hide')
    },

    calculateTotalToJustify () {
      let value = 0.00
      this.arrayJustify.forEach(justify => {
        value += justify.valor
      })
      return value
    },

    generateArrayWithIds (list) {
      let result = []
      list.forEach(item => {
        result.push(item.idMovimentacao ? item.idMovimentacao
          : item.idMovBank ? item.idMovBank : item.id)
      })
      return result
    }
  }
}
</script>

<style>
.confirm-dialog-header {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ApplyModal.vue?640ce9a8